// extracted by mini-css-extract-plugin
export default {"checkStatement":"styles_checkStatement__53+2P","check":"styles_check__aXSzL"};